export function validateEmail(email: string): boolean {
    const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email.trim());
}

export function validatePhoneNumber(phoneNumber: string): boolean {
    const isNum = /^\d+$/;
    return phoneNumber.length === 10 && isNum.test(phoneNumber.trim());
}

export function validateZipAndPostalCode(zipcode: string): boolean {
    const regex = /^(\d{5}(-\d{4})?|[a-zA-Z]\d[a-zA-Z] ?\d[a-zA-Z]\d)$/;
    return regex.test(zipcode.trim());
}

export function validateIsNumber(value: string): boolean {
    const regex = /^[0-9]*$$/;
    return regex.test(value.trim());
}
